import { render, staticRenderFns } from "./ReturnOrderTimeline.vue?vue&type=template&id=17bfdd2c&"
import script from "./ReturnOrderTimeline.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17bfdd2c')) {
      api.createRecord('17bfdd2c', component.options)
    } else {
      api.reload('17bfdd2c', component.options)
    }
    module.hot.accept("./ReturnOrderTimeline.vue?vue&type=template&id=17bfdd2c&", function () {
      api.rerender('17bfdd2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReturnOrderTimeline.vue"
export default component.exports